module.exports = __webpack_public_path__ + "img/de-logo.93395146.svg";